import {Observable} from 'rxjs/Observable'
import {DataService} from 'core/data/service'

export class PbmSevenService extends DataService {
    constructor(){
      super()
    }


    // @Path("/seven/pre-autorizacao")(3)
    // @Path("/seven/autorizacao") (N)
    // @Path("/seven/ativa") (N)
    // @Path("/seven/consulta-preco") (1)
    // @Path("/seven/consulta-preco/ativa")(2)

    postConsultaPreco(preAutorizacao){

      const data = this.buildPreAutorizacao(preAutorizacao);

      const options = {
          method: 'POST',
          url: "/pbm/seven/consulta-preco",
          data: data
      }

      return Observable
              .fromPromise(super.request(options));
    }


    preAutorizacao(preAutorizacao){

      const data = this.buildPreAutorizacao(preAutorizacao);

      const options = {
          method: 'POST',
          url: "/pbm/seven/pre-autorizacao",
          data: data
      }
      
      return Observable
              .fromPromise(super.request(options));
    }


    ativa(preAutorizacao){
      let data = this.buildAtivaRequest(preAutorizacao);

      const options = {
          method: 'POST',
          url: "/pbm/seven/consulta-preco/ativa",
          data: data
      }

      return Observable
              .fromPromise(super.request(options));
    }

    buildDataNascimento(data) {
      if(!data) return null;
      const atr = data.split("/");
      return new Date(atr[2]+"/"+atr[1]+"/"+atr[0]);
    }

    delete_null_properties(obj) {
        for (var i in obj) {
            if (obj[i] === null) {
                delete obj[i];
            } else if (typeof obj[i] === 'object') {
                this.delete_null_properties(obj[i]);
            }
        }
    }




// Integer canalVenda; // required
// Long codigoFilial; // required
// String tipoPrograma; // required - tipos aceitaveis: I-Industria ou C- Convenio
// String usuario; // required
// String cnpjOrigem; // required
// String cpfBeneficiario; // required
// String cpfAtendimento; // required
// String cartaoBeneficiario; // required
// String codigoPrograma; // required
// List<PreAutorizacaoItemRequest> itens; // required
// Long sequenciaPrograma;
// Long codigoConvenio;
// Long codigoAdminConvenio;
// String nsuPreAutorizacao;
// String identificadorTransacao;


    buildPreAutorizacao(data) {
      let preAutoriazacao = {
        "cartaoBeneficiario": data.nroCartao,
        "cpfBeneficiario": data.nroCpf,
        "codigoPrograma": data.sequenciaPrograma,
        "codigoConvenio": data.codigoConvenio,
        "codigoAdminConvenio": data.codigoAdminConvenio,
        "sequenciaPrograma": data.sequenciaPrograma,
        "itens": [
          {
            "codigoItem": data.item,
            "quantidadeSolicitada": data.quantidadeSolicitada
          }
        ]
      }
      return preAutoriazacao;
    }


    buildAtivaRequest(data) {
      let preAutoriazacao = {
        ean: data.ean,
        numeroPreAutorizacao: data.preautorizacao.nsuPreAutorizacao,
        cpf: data.preautorizacao.cpfBeneficiario,
        ativacao: data.cadastro.charAt(data.cadastro.length - 1),
        codigoPrograma: data.sequenciaPrograma,
        codigoConvenio: data.codigoConvenio,
        codigoAdminConvenio: data.codigoAdminConvenio,
        itens: [{
          quantidadeSolicitada: data.quantidadeSolicitada,
          codigoItem: data.item
        }]
      }

      //cadastro form data
      if(data.cadastroFormData) {
        const form = data.cadastroFormData;
        const cadastro = data.cadastro.toUpperCase();

        if(cadastro == 'ATIVA1' || cadastro == 'ATIVA3' || cadastro == 'ATIVA5') {
            preAutoriazacao.ativacaoDadosProfissional = {};
            preAutoriazacao.ativacaoTermos = {};
            preAutoriazacao.ativacaoDadosProfissional.codigoProfissional = form.medicoCrm;
            preAutoriazacao.ativacaoDadosProfissional.nomeProfissional = form.medicoNome;
            preAutoriazacao.ativacaoDadosProfissional.ufProfissional = form.medicoEstado;
            preAutoriazacao.ativacaoTermos.aceitaTermo = form.consumidorAceiteprograma;

        }

        if(cadastro == 'ATIVA2' || cadastro == 'ATIVA3' || cadastro == 'ATIVA4' || cadastro == 'ATIVA5') {
            preAutoriazacao.ativacaoTermos = {};

            if(form.consumidorAceiteprograma)
              preAutoriazacao.ativacaoTermos.aceitaTermo = form.consumidorAceiteprograma;

            if(form.consumidorContatoTelefone)
              preAutoriazacao.ativacaoTermos.contatoViaFone = form.consumidorContatoTelefone;

            if(form.consumidorContatoCorreios)
              preAutoriazacao.ativacaoTermos.contatoViaCorreio = form.consumidorContatoCorreios;

            if(form.consumidorContatoSms)
              preAutoriazacao.ativacaoTermos.contatoViaSMS = form.consumidorContatoSms;

            if(form.consumidorContatoEmail)
              preAutoriazacao.ativacaoTermos.contatoViaEmail = form.consumidorContatoEmail;

            preAutoriazacao.ativacaoDadosBasicos = {};
            preAutoriazacao.ativacaoDadosBasicos.nomeConsumidor = form.consumidorNome;
            preAutoriazacao.ativacaoDadosBasicos.dddCelular = form.consumidorDddCelular;
            preAutoriazacao.ativacaoDadosBasicos.foneCelular = form.consumidorCelular;
        }

        if(cadastro == 'ATIVA4' || cadastro == 'ATIVA5') {
            preAutoriazacao.ativacaoDadosComplementares = {
              ativacaoDadosEndereco: {}
            };
            preAutoriazacao.ativacaoDadosComplementares.dataNascConsumidor = form.consumidorDataNascimento;
            preAutoriazacao.ativacaoDadosComplementares.sexo = form.consumidorSexo;
            preAutoriazacao.ativacaoDadosComplementares.dddFixo = form.consumidorDddTelefone;
            preAutoriazacao.ativacaoDadosComplementares.foneFixo = form.consumidorTelefone;
            preAutoriazacao.ativacaoDadosComplementares.emailConsumidor = form.consumidorEmail;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.cepConsumidor = form.consumidorCep;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.ufConsumidor = form.consumidorEstado;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.cidadeConsumidor = form.consumidorCidade;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.bairroConsumidor = form.consumidorBairro;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.tipoLogradouroConsumidor = form.consumidorTipoLogradouro;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.logradouroConsumidor = form.consumidorLogradouro;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.nrEnderConsumidor = form.consumidorNumero;
            preAutoriazacao.ativacaoDadosComplementares.ativacaoDadosEndereco.complEnderConsumidor = form.consumidorComplemento;

        }

      }

      //clean null attributes
      this.delete_null_properties(preAutoriazacao);

      return preAutoriazacao;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/modal/modal-pbm/pbm-seven/pbm-seven.service.js